import { getCookie } from 'mmbclient/Common/CommonFunctions'
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, MMB_LIVE, RAZORPAY, USER_COOKIE_NAME, USER_TYPE_COOKIE_NAME, WALLET } from 'mmbclient/Common/CommonVariable'
import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify';

function WalletController() {

    const [amount,setAmount] = useState('');
    const [payLoading,setPayLoading] = useState(false);
    const [balance,setBalance] = useState(0);
    const wallet = useContext(WALLET)

    const handleAddMoney=async()=>{
        if(getCookie(USER_TYPE_COOKIE_NAME)===AD)return;
        if(getCookie(APP_TYPE_COOKIE_NAME)===MMB_LIVE)return;
        setPayLoading(true);
        try{
        const appType = getCookie(APP_TYPE_COOKIE_NAME);
        const userKey = getCookie(USER_COOKIE_NAME);
        const cookie = getCookie(LOGIN_COOKIE_NAME)
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

        const path = API_PATH + RAZORPAY + "create-order";
        const resp = await fetch(path,{
            method:"POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams({
                userKey: userKey,
                userCode: c[1],
                amount: amount,
            })
        })
        if(resp.status===200){
            const response = await resp.json();
            const data = JSON.parse(response);
            console.log(data)
            
            console.log(data[0].status)
            if(data[0].status!=="Entry saved."){
                return alert("Try again later! Failed to create order")
            }
            const orderData = data[0].order;
            console.log(data[0])
            const order = JSON.parse(orderData);
            const keyId = data[0].keyId;
            const userCookie = getCookie(USER_COOKIE_NAME);
            const options = {
                "key": keyId, // Enter the Key ID generated from the Dashboard
                "amount": order.amount, // Amount is in currency subunits. 
                "currency": "INR",
                "name": userCookie,
                "description": `Payment to ${userCookie}`,
                "order_id": order.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
                "handler": async function (response){
                    const resp1 = await fetch(API_PATH+RAZORPAY+"verify-payment",{
                        method:"POST",
                        headers:{
                            "Content-Type": "application/x-www-form-urlencoded"
                        },
                        body: new URLSearchParams({
                            payId:response.razorpay_payment_id,
                            orderId:response.razorpay_order_id,
                            signature:response.razorpay_signature,
                            userKey:userKey
                        })
                    });
                    
                    if(resp1.status===200){
                        const responseOrder = await resp1.json();
                        const data = JSON.parse(responseOrder);
                        console.log(data);
                        toast.success(data[0].status, {
                                        autoClose: 2000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                    });
                        console.log(data);
                        console.log("obj.balance: "+ data[0].balance);
                        wallet.setWalletAmount(data[0].balance);
                    }else if(resp1.status===409){
                        const responseOrder = await resp1.json();
                        const data = JSON.parse(responseOrder);
                        console.log(data);
                        alert(data[0].status);
                    }
                    else{
                        alert(resp1);
                    }
                    
                    
                },
                "prefill": {
                    "name": "Gaurav Kumar",
                    "email": "gaurav.kumar@example.com",
                    "contact": "+919876543210"
                },
                "notes": {
                    "address": "Razorpay Corporate Office"
                },
                "theme": {
                    "color": "#3399cc"
                }
            };

            const rzp = new window.Razorpay(options);
            console.log(rzp)
            rzp.open();

            rzp.on('payment.failed', function (response){
                toast.error(response.error.description, {
                                    autoClose: 10000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                console.log(response.error.metadata.order_id);
                console.log(response.error);
            });
        }else if(resp.status===409){
            const response = await resp.json();
            const data = JSON.parse(response);
            console.log(data)
            alert(data[0].status);
            toast.warn(data[0].status, {
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
        }else{
            toast.warn(resp, {
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
        }
        

        }catch(err){
            console.log(err)
        }finally{
            setPayLoading(false);
            setAmount('');
        }

    }

    

  return {handleAddMoney,setAmount,amount,payLoading,balance,setBalance,wallet}
}

export default WalletController
